var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fluent:delete-16-regular") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.313725 0 0 0 0 0.094118 0 0 0 0 0.509804 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fluent:delete-16-regular",
    transform: "translate(-216.000000, -158.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5 L4.5,9 C4.5,9.27614237 4.72385763,9.5 5,9.5 C5.27614237,9.5 5.5,9.27614237 5.5,9 L5.5,5 C5.5,4.72385763 5.27614237,4.5 5,4.5 C4.72385763,4.5 4.5,4.72385763 4.5,5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,4.5 C7.27614237,4.5 7.5,4.72385763 7.5,5 L7.5,9 C7.5,9.27614237 7.27614237,9.5 7,9.5 C6.72385763,9.5 6.5,9.27614237 6.5,9 L6.5,5 C6.5,4.72385763 6.72385763,4.5 7,4.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2 L11,2 C11.2761424,2 11.5,2.22385763 11.5,2.5 C11.5,2.77614237 11.2761424,3 11,3 L10.447,3 L9.695,9.776 C9.55434919,11.0422233 8.48401103,12.0001437 7.21,12 L4.79,12 C3.51598897,12.0001437 2.44565081,11.0422233 2.305,9.776 L1.552,3 L1,3 C0.723857625,3 0.5,2.77614237 0.5,2.5 C0.5,2.22385763 0.723857625,2 1,2 L4,2 C4,0.8954305 4.8954305,0 6,0 C7.1045695,0 8,0.8954305 8,2 Z M6,1 C5.44771525,1 5,1.44771525 5,2 L7,2 C7,1.44771525 6.55228475,1 6,1 Z M2.559,3 L3.299,9.666 C3.38357919,10.4255754 4.02573014,11.0001088 4.79,11 L7.21,11 C7.97388785,10.9995995 8.61546317,10.4251958 8.7,9.666 L9.442,3 L2.56,3 L2.559,3 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.3f592aca828655548ad1ac095b8eed0c.svg";
export { ForwardRef as ReactComponent };